import { cva } from 'class-variance-authority';

const borderColor = 'border-gray-200';

export const containerClasses = cva(
  [
    borderColor,
    'bg-white',
    'border',
    'box-border',
    'flex-col',
    'flex',
    'max-h-64',
    'h-fit',
    'relative',
    'rounded-md',
    'rounded-sm',
    'shadow-md',
    'shadow-sm',
    'text-black',
    'text-sm',
    'min-w-96!',
    'whitespace-nowrap',
    'focus:outline-hidden',
    'overflow-hidden',
  ],
  {
    variants: {},
  },
);

export const itemClasses = cva(
  [
    borderColor,
    'border-b!',
    'block',
    'font-medium',
    'hover:bg-primary-50/50',
    'px-4',
    'h-10',
    'flex',
    'items-center',
    'text-info-700',
    'text-left',
    'w-full',
  ],
  {
    variants: {
      isHighlighted: {
        true: ['bg-primary-50!'],
        false: [],
      },
      isConditional: {
        true: ['opacity-50'],
        false: [],
      },
    },
  },
);

export const listHeaderClasses = [
  'bg-info-50',
  'text-gray-500',
  'px-3',
  'py-1',
  'font-medium',
  'border-b',
  borderColor,
];
